import React, { Component } from 'react';

class Pagination extends Component {
  renderPaginationItems(count, activePage, disabled) {
    let items = new Array(count);

    for (let i = 0; i < count; i++) {
      items.push(
        <li className={`page-item cursor-pointer ${i === activePage ? 'active' : ''} ${disabled ? 'disabled' : ''}`} onClick={() => this.setPage(i, disabled || i === activePage)} key={i}>
          <a className="page-link">{i + 1}</a>
        </li>
      );
    }

    return items;
  }

  setPage(page, disabled) {
    const { setPage } = this.props;

    if (disabled) {
      return;
    }

    setPage(page);
  }

  render() {
    const { count, activePage, disabled } = this.props;

    return (
      <nav aria-label="...">
        <ul className="pagination">
          <li className={`page-item cursor-pointer ${activePage === 0 || disabled ? 'disabled' : ''}`} onClick={() => this.setPage(activePage - 1, activePage === 0 || disabled)}>
            <a className="page-link" tabIndex="-1">
              Previous
            </a>
          </li>
          {this.renderPaginationItems(count, activePage, disabled)}
          <li className={`page-item cursor-pointer ${activePage === count - 1 || disabled ? 'disabled' : ''}`} onClick={() => this.setPage(activePage + 1, activePage === count - 1 || disabled)}>
            <a className="page-link">Next</a>
          </li>
        </ul>
      </nav>
    );
  }
}

export default Pagination;



// WEBPACK FOOTER //
// ./src/app/shared/pagination/components/pagination.js